import "./loading-container.scss";

import { LoadingOutlined } from "@ant-design/icons";
import React, { ReactNode } from "react";

interface LoadingProps {
  isLoading: boolean;
  LoadingComponent?: ReactNode;
  children: any;
}

const DefaultLoadingContainer = () => {
  return (
    <div className="loading-container">
      <LoadingOutlined style={{ fontSize: "24px" }} />
    </div>
  );
};

const LoadingContainer = (props: LoadingProps) => {
  const { isLoading, LoadingComponent, children } = props || {};

  // this can happen, trust me
  if (!children) return null;

  return isLoading ? LoadingComponent ?? <DefaultLoadingContainer /> : children;
};

export default LoadingContainer;
